module.exports = __webpack_public_path__ + "static/img/ic_nav_logo@2x.30899f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_nav_logo@2x.png
// module id = F0Ne
// module chunks = 21